import { render, staticRenderFns } from "./EditorsPickModule.vue?vue&type=template&id=37ca3b76&scoped=true"
import script from "./EditorsPickModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorsPickModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditorsPickModule.vue?vue&type=style&index=0&id=37ca3b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca3b76",
  null
  
)

export default component.exports